import { removeMask } from '@libs/utils/masks/cpf';
import { useEffect, useRef, useState } from 'react';
import { FormInstance } from 'houseform';
import { z } from 'zod';

import { identityUpdateContactSendCode } from '@libs/acp/apis/updateAccount/updateAccountAPI';

interface StepNewInfoProps {
  setCurrentStep: (step: 'newInfo' | 'verificationCode') => void;
  currFlow: 'celular' | 'e-mail';
  setNewData: (newData: string) => void;
  isOpen: boolean;
}
const useStepNewInfo = ({ setCurrentStep, currFlow, setNewData, isOpen }: StepNewInfoProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [inputErrorMessage, setInputErrorMessage] = useState('');
  const [isUpdateButtonDisabled, setIsUpdateButtonDisabled] = useState(true);

  const formRef = useRef<FormInstance>(null);

  const isConfirmationInputValid = z.string().refine((val) => fieldsMatch(val), {
    message: `Esse ${currFlow} é inválido. Verifique e digite novamente`,
  });

  const fieldsMatch = (val: string) => {
    const field = currFlow === 'celular' ? 'phone' : 'email';
    const formValue = formRef.current?.getFieldValue(field)?.value;

    const fieldsAreEmpty = val === '' || formValue === '';

    if (!fieldsAreEmpty && val === formValue) {
      setIsUpdateButtonDisabled(false);
      return true;
    }
    setIsUpdateButtonDisabled(true);
    return false;
  };

  const handleUpdateContact = () => {
    setIsLoading(true);

    const isPhoneFlow = currFlow === 'celular';
    const contactType = isPhoneFlow ? 'phone' : 'email';
    const contactValue = isPhoneFlow ? formRef.current?.getFieldValue('phone')?.value : formRef.current?.getFieldValue('email')?.value;

    const cleanedContact = isPhoneFlow ? removeMask(contactValue) : contactValue;

    if (!cleanedContact) {
      setIsLoading(false);
      return;
    }

    identityUpdateContactSendCode({
        type: contactType,
        contact: cleanedContact,
      })
      .then(() => {
        setNewData(contactValue);
        setCurrentStep('verificationCode');
      })
      .catch((err) => {
        const isAlreadyInUse = err.fields?.[0]?.message.includes('já cadastrado');
        if (isAlreadyInUse) {
          setInputErrorMessage(`Este ${currFlow} já está cadastrado.`);
        } else {
          setInputErrorMessage(`Este ${currFlow} é inválido. Confira seus dados e tente novamente.`);
        }
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!isOpen) {
      formRef.current?.reset();
    }
  }, [isOpen]);

  return {
    handleDataUpdate: handleUpdateContact,
    isLoading,
    inputErrorMessage,
    formRef,
    isConfirmationInputValid,
    isUpdateButtonDisabled,
  };
};

export default useStepNewInfo;
